import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { forkJoin, map, Observable, of, shareReplay, take, takeUntil } from "rxjs";
import { IExamPeriod } from "../../models/exam/exam-period.model";
import dayjs from "dayjs";

@Injectable()
export class ExamPeriodService {
  examMonthDiff?: number;
  examYear?: number;
  periodId?: number;

  nextExamMonthDiff?: number;
  nextExamYear?: number;
  nextPeriodId?: number;
  private cachedData$: Observable<{ examMonthDiff: number; examYear: number, periodId: number }> | null = null;
  private cachedNextPeriodData$: Observable<{ examMonthDiff: number; examYear: number, periodId: number }> | null = null;

  constructor(
    private api: ApiService
  ) {
  }

  getPeriods() {
    return this.api.get(`/public/exam-periods/active`)
  }

  getNextExamPeriods() {
    return this.api.get(`/public/exam-periods/next`);
  }
}
